import React from 'react'

const SigninPage = () => {
    return (
        <div>
            <h1>Sign In Page</h1>
        </div>
    )
}

export default SigninPage
